import {IngredientDataHandler} from "./IngredientDataHandler";
import {RecipeDataHandler} from "./RecipeDataHandler";

export class DataBaseHandler {
    private readonly dbFactory : IDBFactory
    private static _instance : DataBaseHandler
    public db? : IDBDatabase
    public dbLoaded = false

    private constructor() {
        this.dbFactory = window.indexedDB
        if (!this.dbFactory) {
            console.log("IndexedDB could not be found in this browser.");
        }
    }

    public init() {
        return new Promise((resolve, reject) => {
            const request = this.dbFactory.open("ToertchenDataBase", 1);

            request.onerror = function (event) {
                console.error("An error occurred with IndexedDB");
                console.error(event);
                reject(event)
            };

            request.onupgradeneeded = function () {
                const db = request.result;
                IngredientDataHandler.initIngredientSchema(db)
                RecipeDataHandler.initIngredientSchema(db)
            };

            request.onsuccess = function () {
                DataBaseHandler.instance().db = request.result
                DataBaseHandler.instance().dbLoaded = true
                console.log("Database opened successfully");
                resolve(request.result)
            };
        })


    }

    static instance() {
        if (!this._instance) {
            this._instance = new DataBaseHandler()
        }
        return this._instance
    }

    public closeDB() {
        if (this.db) {
            this.db.close()
        }
    }


}
